import { forwardRef, useMemo } from "react";

import { Icons } from "widgets";

import { type Contig } from "../../../../graphql.js";
import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";
import { ENTITY_TYPE } from "../../../../settings/settings.js";

interface ContigTileProps extends Pick<TileProps, "type" | "footNote" | "style"> {
  contig: Contig;
  hideIcon?: boolean;
  noLink?: boolean;
}

const ContigTile = forwardRef<HTMLDivElement, ContigTileProps>(function ContigTile(props, ref) {
  const [title, sequenceId] = useMemo(() => {
    const title = props.contig?.name ?? props.contig?.accession;
    const sequenceId = props.contig?.sequenceId;

    return title ? [title, sequenceId] : [sequenceId, undefined];
  }, [props.contig]);

  if (props.contig == undefined) return null;

  return (
    <Tile
      title={title}
      subtitle={sequenceId}
      to={props.noLink ? undefined : `/${ENTITY_TYPE.CONTIG}/${props.contig.id}`}
      type={props.type !== undefined ? props.type : "Contig"}
      footNote={props.footNote}
      icon={props.hideIcon !== true ? <img src={Icons.Tiles.Entity} width={24} height={30} /> : undefined}
      ref={ref}
      style={props.style}
    >
      {props.contig.description}
    </Tile>
  );
});

export { ContigTile };
